import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function themeModel() {
  const fetchGetThemeDetail = reactive({
    api: apiEndpoint.bcrm_platform + "/theme/Detail",
    method: "GET",
    payload: {
      brand_ref: null,
    },
  });

  return {
    fetchGetThemeDetail,
  };
}
